module.exports = __webpack_public_path__ + "img/BRCA3_Myofibroblasts.a0edc47f.png";